// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IServiceDto } from './IServiceDto';
import {
    IServiceDtoFromJSON,
    IServiceDtoFromJSONTyped,
    IServiceDtoToJSON,
    IServiceDtoToJSONTyped,
} from './IServiceDto';
import type { IAccountOrderDto } from './IAccountOrderDto';
import {
    IAccountOrderDtoFromJSON,
    IAccountOrderDtoFromJSONTyped,
    IAccountOrderDtoToJSON,
    IAccountOrderDtoToJSONTyped,
} from './IAccountOrderDto';

/**
 * 
 * @export
 * @interface IEligibleServicesSearchResponse
 */
export interface IEligibleServicesSearchResponse {
    /**
     * 
     * @type {Array<Array<IAccountOrderDto>>}
     * @memberof IEligibleServicesSearchResponse
     */
    account_orders: Array<Array<IAccountOrderDto>>;
    /**
     * 
     * @type {Array<IServiceDto>}
     * @memberof IEligibleServicesSearchResponse
     */
    deductible_services: Array<IServiceDto>;
}

/**
 * Check if a given object implements the IEligibleServicesSearchResponse interface.
 */
export function instanceOfIEligibleServicesSearchResponse(value: object): value is IEligibleServicesSearchResponse {
    if (!('account_orders' in value) || value['account_orders'] === undefined) return false;
    if (!('deductible_services' in value) || value['deductible_services'] === undefined) return false;
    return true;
}

export function IEligibleServicesSearchResponseFromJSON(json: any): IEligibleServicesSearchResponse {
    return IEligibleServicesSearchResponseFromJSONTyped(json, false);
}

export function IEligibleServicesSearchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): IEligibleServicesSearchResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'account_orders': json['account_orders'],
        'deductible_services': ((json['deductible_services'] as Array<any>).map(IServiceDtoFromJSON)),
    };
}

export function IEligibleServicesSearchResponseToJSON(json: any): IEligibleServicesSearchResponse {
    return IEligibleServicesSearchResponseToJSONTyped(json, false);
}

export function IEligibleServicesSearchResponseToJSONTyped(value?: IEligibleServicesSearchResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'account_orders': value['account_orders'],
        'deductible_services': ((value['deductible_services'] as Array<any>).map(IServiceDtoToJSON)),
    };
}

